import axios from 'axios';
import { EQUIPMENT_API_URL } from '../../comm/config';
import { getAuthToken, getUserInfo } from '../../utils';
import { rewriteOBJ } from '../commlogic';

const API_HOST = EQUIPMENT_API_URL;

const POST_LIST = {
  getViewRequestList: '/loanRequest/list',
  newLoanRequset: '/loanRequest/new',
  getEquipmentList: '/equipment/list',
  getEquipmentChart: '/equipment/chart',
  getRequestDetail: '/loanRequest/detail',
  updateRequestDeclined: '/loanRequest/declined',
  updateRequest: '/loanRequest/update',
  editEquipment: '/equipment/edit',
  updateEquipmentStatus: '/equipment/update',
  registerEquipment: '/equipment/register',
  getLoanRequestDetail: '/loanRequest/detail',
  getBedNo: '/loanRequest/getBedNo',
  checkLocalCode: '/equipment/checkLocalCode',
  offLight: '/wpAlarm/off',
  withdraw: '/loanRequest/withdrawn',
  getAdsLocation: '/ads/location',
  createAds: '/ads/create',
  getServiceType: '/ads/serviceType',
  cancelTransfer: '/transferIn/cancel',
  confirmTransfer: '/transferIn/confirm',
  rejectTransfer: '/transferIn/reject',
  getTransferHistory: '/transfer/historyLog',
  getStaffName: '/emp/getStaffName',
  getEquipment: '/loanRequest/getEquipment',
  getTvDashboardList: '/dashboard/list',
  pingDashboard: '/dashboard/ping',
  getDashboardRemark: '/dashboard/getRemark',
  getDashboardColorList: '/dashboardClr/list',
  updateDashboardColorList: '/dashboardClr/update',
  updateDashboardRemark: '/dashboardRmk/update',
  createEquipmentRemark:'/create/equipmentRemark',
  deleteEquipmentRemark:'/delete/equipmentRemark',
  updateEquipmentRemark:'/update/equipmentRemark',
  getEquipmentAssetList: '/equipmentLend/list',
  returnAdsOrder: '/return/order',
};

const GET_LIST = {
  getEquipmentCategory: '/loanRequest/getEquipmentCategory',
  getCategoryList: '/loanRequest/getEquipmentCategory',
  getProvider: '/equipment/getProvide',
  getAvailableQty: '/loanRequest/getEquipmentAvailableQty',
  getEquipmentModel: '/equipment/getModel',
  getPatientEquipment: '/equipment/getPatient',
  getEquipmentStatus: '/equipment/getStatus',
  getUpdateEquipment: '/equipment/getPatient',
  getRegisterStatus: '/equipment/getRegisterStatus',
  getRequestWard: '/loanRequest/item',
  getEquipmentItem: '/equipment/item',
  getTab: '/loanRequest/tab',
  getAlarmDisplay: '/wpAlarm/display',
  getAdsOrder: '/latest/ads/order',
  getSatelliteStores: '/equipment/getSatelliteStores',
  getEquipmentRemarkList:'/equipmentRemark/list'
};

const EQUIPMENTAPI = {
  POST: POST_LIST,
  GET: GET_LIST,
};

rewriteOBJ(EQUIPMENTAPI, API_HOST);

const getLoanRequestExport = (data) => {
  return axios({
    method: 'post',
    url: `${API_HOST}/loanRequest/export`,
    responseType: 'blob',
    data,
    headers: {
      Authorization: getAuthToken() || '',
      'x-HospitalId': getUserInfo()?.hospId || '',
      'x-WardId': getUserInfo()?.wardId || '',
    },
  });
};

const getEquipmentExport = (data) => {
  return axios({
    method: 'post',
    url: `${API_HOST}/equipment/export`,
    responseType: 'blob',
    data,
    headers: {
      Authorization: getAuthToken() || '',
      'x-HospitalId': getUserInfo()?.hospId || '',
      'x-WardId': getUserInfo()?.wardId || '',
    },
  });
};

export default { ...EQUIPMENTAPI.GET, ...EQUIPMENTAPI.POST, getLoanRequestExport, getEquipmentExport };
